<div class="modal">
  <div class="modal-content">
    <div class="modal-header">
      <h3>Sélectionner des pièces jointes</h3>
      <button class="close-button" (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    
    <div class="modal-body">
      <mat-tab-group [(selectedIndex)]="selectedTabIndex" class="document-tabs">
        <!-- Onglet Documents Patient (tous) -->
        <mat-tab label="Documents Patient">
          <div class="tab-container">
            <div class="tab-content">
              <!-- Barre de recherche -->
              <div class="search-container">
                <mat-form-field  class="search-field">
                  <mat-label>Rechercher un document</mat-label>
                  <input matInput 
                         [formControl]="allPatientSearchControl" 
                         placeholder="Nom du document..."
                         autocomplete="off">
                  <mat-icon matPrefix>search</mat-icon>
                  <button mat-icon-button 
                          matSuffix 
                          *ngIf="allPatientSearchControl.value"
                          (click)="allPatientSearchControl.setValue('')"
                          aria-label="Effacer">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
              
              <div *ngIf="isLoadingAllPatient" class="loading-container">
                <mat-spinner diameter="40"></mat-spinner>
                <p>Chargement des documents...</p>
              </div>
              
              <div *ngIf="!isLoadingAllPatient && filteredAllPatientDocuments.length === 0" class="empty-state">
                <mat-icon>folder_open</mat-icon>
                <p>Aucun document patient disponible</p>
              </div>
              
              <mat-selection-list *ngIf="!isLoadingAllPatient && filteredAllPatientDocuments.length > 0" 
                                  class="document-list">
                <mat-list-option *ngFor="let doc of filteredAllPatientDocuments"
                                 [selected]="doc.selected"
                                 (click)="toggleDocumentSelection(doc)"
                                 checkboxPosition="before">
                  <div class="document-info">
                    <mat-icon class="document-icon">insert_drive_file</mat-icon>
                    <div class="document-details">
                      <span class="document-title">{{ doc.title }}</span>
                      <span class="document-type">{{ doc.contentType }}</span>
                    </div>
                  </div>
                </mat-list-option>
              </mat-selection-list>
            </div>
            
            <!-- Paginator -->
            <mat-paginator [length]="allPatientDocsTotal"
                           [pageSize]="allPatientDocsPageSize"
                           [pageSizeOptions]="pageSizeOptions"
                           [pageIndex]="allPatientDocsCurrentPage"
                           (page)="onAllPatientPageChange($event)"
                           showFirstLastButtons>
            </mat-paginator>
          </div>
        </mat-tab>
        
        <!-- Onglet Documents Patient par consultation -->
        <mat-tab label="Documents Patient par consultation">
          <div class="tab-container">
            <div class="tab-content">
              <div *ngIf="isLoadingConsultations" class="loading-container">
                <mat-spinner diameter="40"></mat-spinner>
                <p>Chargement des consultations...</p>
              </div>
              
              <div *ngIf="!isLoadingConsultations && filteredConsultations.length === 0" class="empty-state">
                <mat-icon>folder_open</mat-icon>
                <p>Aucune consultation trouvée</p>
              </div>
              
              <!-- Liste des consultations avec expansion panels -->
              <mat-accordion *ngIf="!isLoadingConsultations && filteredConsultations.length > 0" class="consultations-accordion">
                <mat-expansion-panel *ngFor="let consultWithDocs of filteredConsultations"
                                     (opened)="onConsultationExpanded(consultWithDocs)"
                                     [(expanded)]="consultWithDocs.isExpanded">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="consult-icon">event</mat-icon>
                      {{ formatConsultationDate(consultWithDocs.consultation.date) }}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{ consultWithDocs.consultation.titre || 'Sans titre' }}
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  
                  <!-- Documents de la consultation -->
                  <div class="consultation-documents">
                    <div *ngIf="consultWithDocs.isLoading" class="documents-loading">
                      <mat-spinner diameter="30"></mat-spinner>
                      <span>Chargement...</span>
                    </div>
                    
                    <div *ngIf="!consultWithDocs.isLoading && consultWithDocs.documents.length === 0" class="no-documents">
                      <mat-icon>description</mat-icon>
                      <span>Aucun document</span>
                    </div>
                    
                    <mat-selection-list *ngIf="!consultWithDocs.isLoading && consultWithDocs.documents.length > 0">
                      <mat-list-option *ngFor="let doc of consultWithDocs.documents"
                                       [selected]="doc.selected"
                                       (click)="toggleDocumentSelection(doc)"
                                       checkboxPosition="before">
                        <div class="document-info">
                          <mat-icon class="document-icon">insert_drive_file</mat-icon>
                          <div class="document-details">
                            <span class="document-title">{{ doc.title }}</span>
                            <span class="document-type">{{ doc.contentType }}</span>
                          </div>
                        </div>
                      </mat-list-option>
                    </mat-selection-list>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
            
            <!-- Paginator -->
            <mat-paginator [length]="totalConsultations"
                           [pageSize]="pageSize"
                           [pageSizeOptions]="pageSizeOptions"
                           [pageIndex]="currentPage"
                           (page)="onPageChange($event)"
                           showFirstLastButtons>
            </mat-paginator>
          </div>
        </mat-tab>
        
        <!-- Onglet Documents Utilisateur -->
        <mat-tab label="Documents Utilisateur">
          <div class="tab-container">
            <div class="tab-content">
              <!-- Barre de recherche -->
              <div class="search-container">
                <mat-form-field appearance="outline" class="search-field">
                  <mat-label>Rechercher un document</mat-label>
                  <input matInput 
                         [formControl]="userSearchControl" 
                         placeholder="Nom du document..."
                         autocomplete="off">
                  <mat-icon matPrefix>search</mat-icon>
                  <button mat-icon-button 
                          matSuffix 
                          *ngIf="userSearchControl.value"
                          (click)="userSearchControl.setValue('')"
                          aria-label="Effacer">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
              
              <div *ngIf="isLoadingUser" class="loading-container">
                <mat-spinner diameter="40"></mat-spinner>
                <p>Chargement des documents...</p>
              </div>
              
              <div *ngIf="!isLoadingUser && filteredUserDocuments.length === 0" class="empty-state">
                <mat-icon>folder_open</mat-icon>
                <p>Aucun document utilisateur disponible</p>
              </div>
              
              <mat-selection-list *ngIf="!isLoadingUser && filteredUserDocuments.length > 0" 
                                  class="document-list">
                <mat-list-option *ngFor="let doc of filteredUserDocuments"
                                 [selected]="doc.selected"
                                 (click)="toggleDocumentSelection(doc)"
                                 checkboxPosition="before">
                  <div class="document-info">
                    <mat-icon class="document-icon">insert_drive_file</mat-icon>
                    <div class="document-details">
                      <span class="document-title">{{ doc.title }}</span>
                      <span class="document-type">{{ doc.contentType }}</span>
                    </div>
                  </div>
                </mat-list-option>
              </mat-selection-list>
            </div>
            
            <!-- Paginator -->
            <mat-paginator [length]="userDocsTotal"
                           [pageSize]="userDocsPageSize"
                           [pageSizeOptions]="pageSizeOptions"
                           [pageIndex]="userDocsCurrentPage"
                           (page)="onUserPageChange($event)"
                           showFirstLastButtons>
            </mat-paginator>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
    
    <!-- Footer avec bouton d'ajout -->
    <div class="modal-footer">
      <button mat-raised-button 
              color="primary"
              [disabled]="selectedDocumentsCount === 0"
              (click)="addSelectedDocuments()">
        <mat-icon>add</mat-icon>
        Ajouter {{ selectedDocumentsCount }} document{{ selectedDocumentsCount > 1 ? 's' : '' }} sélectionné{{ selectedDocumentsCount > 1 ? 's' : '' }}
      </button>
    </div>
  </div>
  <div class="modal-background"></div>
</div>
